/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_Start_BlankInputs */

const en_resumes_start_blank = /** @type {(inputs: Resumes_Start_BlankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start blank`)
};

const de_resumes_start_blank = /** @type {(inputs: Resumes_Start_BlankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leer beginnen`)
};

const fr_resumes_start_blank = /** @type {(inputs: Resumes_Start_BlankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer vide`)
};

const es_resumes_start_blank = /** @type {(inputs: Resumes_Start_BlankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empezar en blanco`)
};

const it_resumes_start_blank = /** @type {(inputs: Resumes_Start_BlankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia da zero`)
};

const nl_resumes_start_blank = /** @type {(inputs: Resumes_Start_BlankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begin blanco`)
};

const pl_resumes_start_blank = /** @type {(inputs: Resumes_Start_BlankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zacznij od zera`)
};

const fi_resumes_start_blank = /** @type {(inputs: Resumes_Start_BlankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aloita tyhjästä`)
};

const da_resumes_start_blank = /** @type {(inputs: Resumes_Start_BlankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start tom`)
};

const sv_resumes_start_blank = /** @type {(inputs: Resumes_Start_BlankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Börja tomt`)
};

/**
* | output |
* | --- |
* | "Start blank" |
*
* @param {Resumes_Start_BlankInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_start_blank = /** @type {((inputs?: Resumes_Start_BlankInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_Start_BlankInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_start_blank(inputs)
	if (locale === "fr") return fr_resumes_start_blank(inputs)
	if (locale === "es") return es_resumes_start_blank(inputs)
	if (locale === "it") return it_resumes_start_blank(inputs)
	if (locale === "nl") return nl_resumes_start_blank(inputs)
	if (locale === "pl") return pl_resumes_start_blank(inputs)
	if (locale === "fi") return fi_resumes_start_blank(inputs)
	if (locale === "da") return da_resumes_start_blank(inputs)
	if (locale === "sv") return sv_resumes_start_blank(inputs)
	return en_resumes_start_blank(inputs)
});